
@if (is_my_files) {
    <div class="spinner-overlay">
        <span class="loader"> </span>
    </div>   
}@else{
    <div *ngIf="loading$ | async" class="spinner-overlay">
        <span class="loader"> </span>
    </div>
}